export const sclUtilUrlService = {
  getDocIdFromLink(link: string): string | null {
    const lstIdx = link.lastIndexOf('/');
    if (!link || lstIdx === -1) return null;
    return link.substring(lstIdx + 1);
  },

  openLink(link: string, mode?: string, componentScope?: any) {
    const openMode = mode || 'currentWindow';
    switch (openMode) {
      case 'currentWindow':
        window.location.href = link;
        break;

      case 'newWindow':
        window.open(link, '_blank');
        break;

      case 'popup':
        window.open(link, undefined, 'height=300,width=600');
        break;

      case 'overlay': {
        const documentModalService = (globalThis as any).FormbirdServiceInjector.get('DocumentModalService');
        const documentId = this.getDocIdFromLink(link);
        if (componentScope) componentScope.selectedDocumentId = documentId;
        documentModalService.openDocumentInModal(documentId, componentScope);
        break;
      }

      case 'noDisplay':
        break;

      default:
        window.location.href = link;
        break;
    }
  }
};
